'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SalesPartnerActionTypes = (0, _keyMirror2.default)({
  PORTAL_SELECTED: null,
  SALES_PARTNER_PROVISIONING_COMPLETED: null,
  SALES_PARTNER_PROVISIONING_FAILED: null
});

exports.default = SalesPartnerActionTypes;
module.exports = exports['default'];